<template>
  <div id="video"></div> 
</template>

<script>
export default {
  props: {
    source:{
      type: String
    },
  },
  async mounted() {
    console.log(this.source)
      await window.jwplayer('video').setup({ 
        sources: [{file:this.source}],
        width: "100%"
      })
    await window.jwplayer("video").on('play', function(evt){
        console.log("viewable", evt)
        // console.log("this.canPublish",this.canPublish)
        }.bind(this)
      )
      await window.jwplayer("video").on('error', function(evt){
      //   console.log("errrrrrrrrr")
      // console.log("evt", evt)
        let timer = null
        clearInterval(timer);

        window.jwplayer("video").stop();
        // while(repeat == true){
        timer=setTimeout(function()
          {
            window.jwplayer("video").play();
          },10000);
        // }
    }.bind(this)
    );
    console.log("init")
  },
  methods: {}
};
</script>
